import CircleIcon from 'components/CircleIcon';
import QuoteBookingComponentIcon from 'components/quoteBooking/QuoteBookingComponentIcon';
import SectionTitle from 'components/typography/SectionTitle';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { COMPONENT_CAR_HIRE } from 'shared/constants/common';
import CarHiresItem from './CarHiresItem';

export default function CarHires({ carHiresList = [] }) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <QuoteBookingComponentIcon
            componentType={COMPONENT_CAR_HIRE}
            fillColor={primaryColour}
          />
        </CircleIcon>
        <SectionTitle label="Car Hires" className="ml-[10px] mt-1" />
      </div>
      {carHiresList.map((carHire, index) => (
        <div key={`${index + 1}`} className="mt-[40px]">
          <CarHiresItem carHire={carHire} />
        </div>
      ))}
    </>
  );
}
